export default {
  START: "FETCH_TIMESHEET_USERS",
  SUCCESS: "FETCH_TIMESHEET_SUCCESS",
  FAIL: "FETCH_TIMESHEET_FAIL",
};
